// extracted by mini-css-extract-plugin
export var alert = "HeldBet-module--alert--5a061";
export var button = "HeldBet-module--button--96bbd";
export var footer = "HeldBet-module--footer--db6bc";